module.exports = __webpack_public_path__ + "static/CLS_WF-9d6d46181680cfe07afc0b978b2cd3fc.png";